






































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { State, Action, namespace } from 'vuex-class'
import { CollegeProduct } from '@/model/product/collegeProduct'
import { Course, Child, Outline, MyLearn } from '@/model/course/course'
import { OrderInfo } from '@/api/product/product'
import { ProductObj } from '@/apps/ice/store/modules/product/index'
import { queryCourseProduct } from '@/api/product/product'
import CourseItem from './course_item.vue'
import { CourseProduct, CourseProductView } from '@/model/product/courseProduct'
import { Authority } from '@/apps/ice/model/authority'
import { productService } from '@/apps/ice/utils/product_timelimit.ts'
import moment from 'moment'

const ModuleProduct = namespace('app-ice/product')
const ModuleUser = namespace('app-ice/user')

@Component({
  components: {
    CourseItem,
  },
})
export default class College extends Vue {
  @ModuleProduct.State((state) => state.productObj)
  private productObj?: ProductObj
  @ModuleProduct.Action('showAllCourseModal')
  showAllCourseModal!: Function

  @ModuleProduct.State((state) => state.productList)
  private productList?: CollegeProduct[]
  @ModuleProduct.Action('queryProductList')
  queryProductList!: Function

  @ModuleUser.State((state) => state.myLearn)
  myLearn?: MyLearn
  @ModuleUser.Getter('currentCourse')
  currentCourse?: Child
  @ModuleUser.Action('handleMyLearn')
  handleMyLearn!: Function

  @Prop()
  private collegeType!: string
  @Prop()
  private authority!: Authority

  // private localProductList: any = ''
  private activeTabIndex: number = 0
  Authority: any = Authority

  show() {
    this.handleMyLearn()
    this.showAllCourseModal()
  }

  get timeLimitStr() {
    if (this.timeLimit && this.timeLimit.serve && this.timeLimit.payTime) {
      const payTime = this.timeLimit.payTime
      const expiryDate = this.timeLimit.expiryDate
      const lastDiff = this.timeLimit.serve.lastDiff || 0
      const diff = this.timeLimit.serve.diff || 0

      let start = moment(payTime).format('YYYY-MM-DD')
      let end = moment(expiryDate).format('YYYY-MM-DD')
      if (
        moment(expiryDate).isAfter(moment(payTime).add(diff + lastDiff, 'day'))
      ) {
        start = moment(payTime).add(lastDiff, 'day').format('YYYY-MM-DD')
        end = moment(payTime).add(diff + lastDiff, 'day').format('YYYY-MM-DD')
      }

      return `${start} 至 ${end}`
    }

    return ''
  }

  get timeLimit() {
    if (this.authority !== Authority.COLLEGE && this.myLearn) {
      return this.myLearn.timeLimit
    }
    if (this.localProductList && this.localProductList.length) {
      return this.localProductList[this.activeTabIndex].timeLimit
    }
    return undefined
  }

  @Watch('collegeType', {
    immediate: true,
  })
  async collegeTypeChange() {
    this.activeTabIndex = 0
    if (this.productObj && this.collegeType) {
      this.queryProductList(this.collegeType)
    }
  }

  get localProductList() {
    if (this.authority === Authority.COLLEGE) {
      return this.productList
    }
    return []
  }

  // resizeImg(src: string, size: number): string {
  //   if (!src || src.indexOf('image/resize') !== -1) {
  //     return src
  //   }
  //   return `${src}?x-oss-process=image/resize,m_lfit,w_${size}`
  // }

  // private format(dtstr: string) {
  //   return (/(\d+)-(\d+)-(\d+)/.exec(dtstr) || [''])[0]
  // }

  get empty() {
    if (this.authority === Authority.COLLEGE) {
      return this.localProductList && this.localProductList.length === 0
    } else if (this.myLearn && this.myLearn.courses) {
      return this.myLearn.courses.length === 0
    }
    return false
  }

  lineLight(products: CourseProductView[] | Child[], i: number): boolean {
    if (!products || products.length - 2 < i) {
      return false
    }

    let property = 'id'

    if (products[0].hasOwnProperty('courseId')) {
      property = 'courseId'
    }
    const curFinish =
      !!products[i].myCourse && products[i].myCourse!.process >= 100
    const nextFinish =
      !!products[i + 1].myCourse && products[i + 1].myCourse!.process >= 100

    const curProductMark =
      curFinish ||
      (!!this.currentCourse && products[i][property] === this.currentCourse.id)
    const nextProductMark =
      nextFinish ||
      (!!this.currentCourse &&
        products[i + 1][property] === this.currentCourse.id)

    return curProductMark && nextProductMark
  }
}
